import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bellFilled"
const BellFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.602 18.771C18.91 19.965 18.2 21.186 17.005 21.505 15.805 21.827 14.572 21.115 14.25 19.915zM12 1.5C12.828 1.5 13.5 2.172 13.5 3V3.13C14.43 3.3 15.202 3.629 15.839 4.072 16.786 4.73 17.379 5.604 17.749 6.45 18.119 7.292 18.273 8.123 18.336 8.735 18.368 9.043 18.378 9.3 18.38 9.485Q18.38 9.626 18.377 9.706L18.375 9.768V12.573L20.442 16.706 19.969 17.086 19.5 16.5C19.964 17.08 19.968 17.087 19.968 17.087H19.967L19.965 17.09 19.961 17.092 19.95 17.1 19.919 17.123Q19.883 17.15 19.82 17.191 19.699 17.272 19.472 17.397C19.168 17.559 18.715 17.763 18.088 17.964 16.832 18.366 14.879 18.75 12 18.75S7.168 18.366 5.912 17.964C5.285 17.764 4.832 17.56 4.528 17.397Q4.3 17.272 4.179 17.19 4.118 17.15 4.081 17.123L4.051 17.101 4.038 17.09 4.035 17.09 4.033 17.087H4.032S4.036 17.08 4.5 16.5L4.031 17.086 3.558 16.706 5.625 12.574V9.768L5.623 9.705Q5.62 9.625 5.62 9.485C5.622 9.302 5.632 9.044 5.665 8.736 5.728 8.123 5.882 7.292 6.25 6.45 6.62 5.604 7.214 4.73 8.161 4.072 8.798 3.629 9.571 3.3 10.5 3.13V3C10.5 2.172 11.172 1.5 12 1.5" />
        </svg>
      }
    </span>
  )
}
export default BellFilledIcon
